// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c93c56af","455":"ea1aa2fe","977":"60c340e1"}[chunkId] + ".chunk.js";
};